import React, { useEffect, useState } from "react";
import { Checkbox, Form, message, Row, Col } from "antd";
import { SaveButton, InputText, InputTextArea, CancelButton, ModalComponent, trans } from "@comps/components"
import { makeRequest, getErrorProps } from "@utils/helpers";
import { createDataReq } from "../requests";
import { Commons, Const } from "../../../constants";
import { makeFieldLabel } from "@utils/fieldTooltips";
import { travelTooltips } from "../../../common/travelTooltips";
const langKey = Const["travelMode"].lngKey
const fieldLabel = makeFieldLabel(travelTooltips.travelMode, { namespace: "travelMode", label: (key) => trans(`${langKey}.${key}`) });
const formName = "createTravelMode";

const CreateTravelMode = (props) => {
  const [loader, setLoader] = useState(false);
  const [saving, setsaving] = useState(false);
  const [errors, setErrors] = useState([]);

  useEffect(() => {
    // eslint-disable-next-line
  }, []);

  const onSubmit = (data) => {
    setsaving(true)
    const payload = { travel_mode: data };
    makeRequest(setLoader, createDataReq, payload, onSuccess, onError);
  }

  const onSuccess = (data, res) => {
    message.success("Saved successfully");
    props.onCompleted(data.travel_modes.data);
    props.onSuccess(data)
  }

  const onError = (err, res) => {
    setsaving(false)
    message.error(res.response.data.message);
  }

  //-----------------------
  // ------------------------------------
  // Start footer buttons array
  // ------------------------------------

  const footer = [
    <SaveButton loading={ saving } form={ formName } key="create_button" htmlType="submit" />,
    <CancelButton key="close_button" onClick={ () => props.onCompleted(false) } />
  ];

  // ------------------------------------
  // Eend footer buttons array
  // ------------------------------------

  return (
    <ModalComponent top={ 20 } width={ 1000 } maskClosable={ false }
      mainTitle={ trans(Commons.create) } subTitle={ trans(`${langKey}.moduleName`) }
      visible={ true } footer={ footer } onCancel={ () => props.onCompleted(false) }>
      <Form { ...formLayout } name={ formName } onFinish={ onSubmit }>
        <Row gutter={ 30 }>
          <Col lg={ 12 } sm={ 24 } xs={ 24 }>
            <Form.Item name="name" rules={ rules.name } label={ fieldLabel("name", trans(Commons.name)) }
              className="da-mb-16"
              { ...getErrorProps(errors['name']) } size="small"
            >
              <InputText placeholder={ trans(`${langKey}.name`) } />
            </Form.Item>
          </Col>

          <Col lg={ 12 } sm={ 24 } xs={ 24 }>
            <Form.Item name="description" rules={ rules.description } label={ fieldLabel("description", trans(Commons.description)) }
              className="da-mb-16"
              { ...getErrorProps(errors['description']) } size="small"
            >
              <InputTextArea placeholder={ trans(`${langKey}.description`) } />
            </Form.Item>
          </Col>

          <Col lg={ 12 } sm={ 24 } xs={ 24 }>
            <Form.Item name="is_active" valuePropName="checked" rules={ rules.is_active } label={ fieldLabel("is_active", trans(Commons.is_active)) }
              className="da-mb-16"
              { ...getErrorProps(errors['is_active']) } size="small"
            >
              <Checkbox defaultChecked={ true } />
            </Form.Item>
          </Col>
        </Row>

      </Form>
    </ModalComponent>
  )
}

export default CreateTravelMode

const rules = {
  name: [
    { required: true, message: trans(`${langKey}.name.req`) },
  ],

};

const formLayout = {
  layout: "vertical",
  labelCol: { span: 6 },
  wrapperCol: { span: 24 },
  labelAlign: "left"
}